import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ProgressBar from "../../common/progress/ProgressBar";
import Spinner from "../../common/progress/Spinner";
import * as types from "../dashboardActionTypes";
import WidgetErrorMessage from "./WidgetErrorMessage";
import WidgetReloader from "./WidgetReloader";
import * as actions from "../dashboardActions";
import {
  getSystemStatus,
  getSystemStatusHasErrors,
  getSystemStatusIsLoading
} from "../dashboardSelector";
import Widget from "./Widget";
import SystemStatusWidgetTable from "./SystemStatusWidgetTable";
import dateUtil from "../../common/date/dateUtil";
import translate from "react-i18next/dist/commonjs/translate";
import WidgetOverlayLinkToTa from "./WidgetOverlayLinkToTa";
class SystemStatusWidget extends Component {
  constructor(props) {
    super(props);
    this.onReload = this.onReload.bind(this);
  }

    componentDidMount() {
        if (this.props.customerInformation.siem != "wazuh") {
            this.props.actions.loadSystemStatus();
        }
  }

  onReload() {
      if (this.props.customerInformation.siem != "wazuh") {
          this.props.actions.loadSystemStatus();
      }
  }

  render() {
      const { customerInformation, hasErrors, isLoading, systemStatus, t } = this.props;

      const mockData =
      {
          "id": "c0001",
          "isSLAFullfilled": true,
          "uptimePercentageLastYear": "99.5",
          "totalThresholdGb": 100,
          "usedLogSpace": 20,
          "freeLogSpace": 80,
          "lac0001DownTime": "2023-10-29 00:00:00",
          "downTimeDurationInMinutes": 125,
          "isLowLogSpace": false
      };
      

      const mockDowntime = dateUtil.minutesToHoursAndMinutes(
          mockData.downTimeDurationInMinutes
      );


      if (customerInformation.siem === "wazuh") {
          return (
              <Widget header={t("systemStatusWidgetTitle")} onReload={this.onReload}>
                  <WidgetOverlayLinkToTa buttonText={t("logInToTa")} taUrl={customerInformation.technicalAnalysisUrl} />
                  <SystemStatusWidgetTable
                      systemStatus={mockData}
                      downtime={mockDowntime}
                  />
              </Widget>
          );
      }
    if (isLoading) {
      return (
        <Widget
          header={t("systemStatusWidgetTitle")}
          onReload={this.onReload}
          isLoading={isLoading}
        >
          <div className="pie-wrapper align-center">
            <div className="text-center">
              <Spinner />
            </div>
          </div>
        </Widget>
      );
    }

    if (hasErrors) {
      return (
        <Widget header={t("systemStatusWidgetTitle")} onReload={this.onReload}>
          <div className="overlay overlay-default">
            <WidgetErrorMessage onClick={this.onReload} />
          </div>
        </Widget>
      );
    }
    const downtime = dateUtil.minutesToHoursAndMinutes(
      systemStatus.downTimeDurationInMinutes
    );
    return (
      <Widget header={t("systemStatusWidgetTitle")} onReload={this.onReload}>
        <SystemStatusWidgetTable
          systemStatus={systemStatus}
          downtime={downtime}
        />
      </Widget>
    );
  }
}

SystemStatusWidget.propTypes = {
  systemStatus: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  hasErrors: PropTypes.bool.isRequired,
    actions: PropTypes.object.isRequired,
    customerInformation: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    systemStatus: getSystemStatus(state),
    isLoading: getSystemStatusIsLoading(state),
      hasErrors: getSystemStatusHasErrors(state),
      customerInformation: state.customerInformation
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
};

export default translate("translations")(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SystemStatusWidget)
);



// WEBPACK FOOTER //
// ./src/dashboard/widgets/SystemStatusWidget.js